import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

export const locales = {
  en: { title: "English" },
  de: { title: "Deutsch" },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: Object.keys(locales),
    // debug: process.env.NODE_ENV === "development",
    fallbackLng: "en",
    resources: {
        en: {
            translation: require('./assets/translations/en.json')
        },
        de: {
            translation: require('./assets/translations/de.json')
        },
    },
    interpolation: {
      escapeValue: false, // not needed for React
    },
  });
export default i18n;
